

































import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { ISchedule, ScheduleUserList } from '@/store/modules/views/schedule/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class EditScheduleDialog extends VueExtendedBaseComponent {

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get editScheduleDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editScheduleAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  // get validateInput() {
  //   return this.nameValidate(this.name)
  // }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private schedule!: ISchedule
  private loading = false
  private urlSchedule = ''

  private valid = false
  private startTime = ''
  private endTime = ''
  private startDate = ''
  private endDate = ''
  private totalPrice = 0
  private useritems!: string
  // private urlUser = ''
//   private urlScheduleCenter = ''

  private userLists = []

  // public async getUserById() {
  //   return await HttpRequestServiceWithToken
  //     .get(this.urlUser, {}, ( response: { name: string, _id: string }) => {
  //       this.useritems = response._id
  //       return response
  //     })
  // }

  private requireSelect(value) { return [(v) => !!v || 'ข้อมูลจำเป็นต้องเลือก'] }

  private async created() {
    this.startDate = this.schedule.startDate || ''
    this.endDate = this.schedule.endDate || ''
    this.startTime = this.schedule.startTime  || ''
    this.endTime = this.schedule.endTime  || ''
    this.totalPrice = this.schedule.totalPrice  || 0
    this.urlSchedule = `${process.env.VUE_APP_API_URL}/v1/all/schedule/${this.schedule._id}`
    // this.urlUser = `${process.env.VUE_APP_API_URL}/v1/all/user/${this.schedule.userId}`
    this.useritems = this.schedule.userId
    await Promise.all([
      // this.getUserById(),
      this.getUserAvailableByDate(),
    ])
  }

  private async getUserAvailableByDate() {
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', `schedule/user-available`, {
        params: {
          startDate: this.startDate,
          endDate: this.endDate,
          centerId: this.schedule.centerId,
        },
      }, (res: ScheduleUserList) => {
        this.userLists = _.map(res.result, (user) => {
          return {
            ...user,
            name: this.mapFullName(user),
          }
        })
      })
  }

  private requireInput(value) {  return value !== '' || 'จำเป็นต้องกรอก' }

  get invalidateInput() {
    return _.some(
        [
        ],
        (item) => item !== true,
    )
  }

  private async editScheduleAction() {
    // const validate = this.formInstant.validate()
    // if (validate) {
      this.loading = true
      const scheduleData = {
        edit: {
          userId: this.useritems,
        },
      }
      try {
        await Promise.all([
          HttpRequestServiceWithToken.put(this.urlSchedule, scheduleData.edit),
        ])
        this.updateSnackbar({txt: 'แก้ไขข้อมูลสำเร็จ', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        this.loading = false
      }
    // }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
